import styled from '@emotion/styled'
import { useMemo } from "react";
import { usePresetTimes } from "../../atom/presetTime";
import TimeListItem from "./render/TimeListItem";

type PresetTimePreviewProps = {
  ids: number[]
}

const PresetTimePreview = (props: PresetTimePreviewProps) => {
  const { ids } = props;
  const { data } = usePresetTimes()
  const filterData = useMemo(() => {
    return data?.filter((item) => ids.includes(item.id) && item.isEffective)
  }, [data, ids])

  return (
    <Container>
      {
        filterData?.map((item) => {
          return (
            <TimeListItem key={item.id} dataSource={item} />
          )
        })
      }
    </Container>
  )
}

const Container = styled.div`
  margin-top: 8px;
`

export default PresetTimePreview;
